import { Globe } from "lucide-react";
import React, { useState } from "react";

export default function MyTabs({ tabs, position = "right", children ,className=""}) {
  const [active, setActive] = useState(0);

  // Choose alignment dynamically
  const alignment =
    position === "left"
      ? "justify-start items-end"
      : position === "center"
      ? "justify-center"
      : "justify-end";

  return (
    <div className={`w-full flex flex-col ${alignment} `}>
      {/* Tab Headers */}
      <div className={`w-full mb-4 flex  ${alignment} ${className} `}>
        <div className="flex space-x-4 w-fit bg-slate-300/30 dark:bg-slate-400/20 rounded-md border-gray-300 p-[4px] ">
          {tabs.map((tab, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`px-2 py-[8px] text-xs font-semibold  rounded-md flex flex-row items-center justify-center space-x-1
              ${
                active === i
                  ? "  text-blue-500  bg-white shadow-md"
                  : "text-gray-600 dark:text-white hover:text-blue-600"
              }`}
            >
              {tab.icon && <tab.icon className="w-[15px] h-[15px]" />}
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
        {children}
      </div>

      {/* Tab Content */}
      <div className="w-full ">{tabs[active].content}</div>
    </div>
  );
}
